export default __webpack_public_path__ + "static/media/nonvegDiet.26c50642.jpg";